import "./epicLeaderboard.css";

const HEADERS = ["Rank", "Player", "Fastest", "Average", "Runs", "Last run"];
const COLUMN_WIDTHS = ["30%", "70%", "60%", "50%", "35%", "55%"];
const HIDDEN_ON_MOBILE = [3, 5];
const SKELETON_ROWS = 8;

const hiddenClass = (index: number) =>
  HIDDEN_ON_MOBILE.includes(index) ? "d-none d-md-table-cell" : undefined;

const EpicLeaderboardTableSkeleton = () => (
  <div className="epic-lb-table-scroll">
    <table className="epic-lb-table">
      <thead>
        <tr>
          {HEADERS.map((header, i) => (
            <th key={header} className={hiddenClass(i)}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: SKELETON_ROWS }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {COLUMN_WIDTHS.map((width, colIndex) => (
              <td key={colIndex} className={hiddenClass(colIndex)}>
                <div className="epic-lb-skeleton-bar" style={{ width }} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default EpicLeaderboardTableSkeleton;
